import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useAuth0 } from "@auth0/auth0-react"
import { z } from "zod"
import AuthError from "~/components/reusable/errors/AuthError"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"

const productSearchSchema = z.object({
  invitation: z.string().optional(),
  organization: z.string().optional(),
  redirect: z.string().optional(),
})

export const Route = createFileRoute("/login/")({
  component: RouteComponent,
  validateSearch: productSearchSchema,
  errorComponent: AuthError,
})

function RouteComponent() {
  const { isAuthenticated, loginWithRedirect, error, isLoading } = useAuth0()
  const navigate = useNavigate()

  const { invitation, organization } = Route.useSearch()

  if (isLoading) return <LoadingOverlay size="lg" height="h-[100vh]" messages="Authenticating..." />

  if (error) {
    return <AuthError />
  } else if (invitation && organization) {
    // Must win over isAuthenticated: a logged-in user opening an invitation
    // link still has to go through Auth0 to accept it, or it's silently dropped
    loginWithRedirect({
      appState: { returnTo: "/" },
      authorizationParams: { invitation, organization, screen_hint: "signup" },
    })
  } else if (isAuthenticated) {
    navigate({ to: "/" })
  } else {
    loginWithRedirect({ appState: { returnTo: "/" } })
  }

  return <></>
}
